"use strict";

Fotobook.displayRegions = {
    regions : {},
    regionsArray : [],
    getRegion :  function(regionName, getAny = false) {
        var region;
        if (typeof regionName === "string"){
            regionName = [regionName];
        }
        if (!(regionName instanceof Array)) {
            throw "regionName expected to be string or array - " + (typeof regionName) + " given.";
        }
        for (var i=0; i<regionName.length; i++){
            if (region = this.regions[regionName[i]]) {
                return region;
            }
        }
        return getAny ? this.regionsArray[0] : undefined;
    },
    getAll: function(){
        return $.extend({}, this.regions);
    },
    /** Устанавливаем размеры зоны переплёта (корешок не входит!) */
    setBindingAreaSize: function(displayProps){
        var bindingSize = displayProps.k * (Fotobook.book.bookbind.binding_area || 0);

        displayProps.bindingAreaWidth = bindingSize;
        displayProps.bindingAreaSize = {
            "width": 0,
            "height": 0,
        };

        switch (Fotobook.book.product.has_bookbind) {
            case Fotobook.BookbindPosition.LEFT_RIGHT:
            case Fotobook.BookbindPosition.LEFT:
            case Fotobook.BookbindPosition.RIGHT:
                displayProps.bindingAreaSize.width = bindingSize;
                break;

            case Fotobook.BookbindPosition.TOP:
            case Fotobook.BookbindPosition.BOTTOM:
            case Fotobook.BookbindPosition.TOP_BOTTOM:
                displayProps.bindingAreaSize.height = bindingSize;
                break;
        }
    },
    createRegionData: function(region){
        var data = {},
            bookbind = Fotobook.book.bookbind,
            product = Fotobook.book.product,
            cover = region.region_type === Fotobook.PageType.COVER;

        data.orig_width = parseFloat(region.width);
        data.orig_height = parseFloat(region.height);
        if (cover && bookbind) {
            // todo вертикальные развороты
            data.orig_width += parseFloat(bookbind.turn_in) + parseFloat(bookbind.width_bonus);
            data.orig_height += 2*parseFloat(bookbind.height_bonus);
        }
        data.k = 2*(screen.width + screen.height) / (data.orig_height + data.orig_width);
        data.height = data.k * data.orig_height;
        data.width = data.k * data.orig_width;

        data.spineWidth = cover ? data.k * Fotobook.book.spineWidth : 0;
        data.bleed_box = data.k * parseInt(cover ? product.cover_bleed_box : product.bleed_box, 10);

        this.setBindingAreaSize(data);
        data.art_box = {
            "safe_area"       : data.k * parseInt(product.safe_area, 10),
            "safe_area_inner" : data.k * parseInt(product.safe_area_inner, 10) + data.bindingAreaWidth,
        };

        return data;
    },
    recalc: function(){
        var allSizeRegions = Fotobook.book.size.regions,
            sizeRegion, displayRegion;

        this.regions = {};
        this.regionsArray = [];
        for (var regionName in allSizeRegions){
            if (!allSizeRegions.hasOwnProperty(regionName)){
                continue;
            }
            sizeRegion = allSizeRegions[regionName];
            displayRegion = this.createRegionData(sizeRegion);
            this.regions[sizeRegion.region_type] = displayRegion;
            this.regionsArray.push(displayRegion);
        }
    },
};
